export default __webpack_public_path__ + "static/muhammad-atique-yousaf-5470ea89bdc4a722d4cae4fc72bc2566.jpg";